import { memoize } from "lodash";
import * as Long from "long";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingQuests = function () { return utilBalancing.getBalancing().Quests; };
export var selectFinishedQuestRewards = memoize(function (questId) {
    var finishedQuest = selectBalancingQuests().get(questId);
    if (finishedQuest !== undefined && finishedQuest.resourceReward) {
        return finishedQuest.resourceReward.map(function (val) {
            return ({
                amount: Long.fromValue(val.amount),
                stageId: 0,
                typeId: val.resourceId,
            });
        });
    }
    else {
        return [];
    }
});
export var selectFinishedQuestXp = memoize(function (questId) {
    var finishedQuest = selectBalancingQuests().get(questId);
    if (finishedQuest != undefined && finishedQuest.xp) {
        return Long.fromValue(finishedQuest.xp.amount);
    }
    else {
        return undefined;
    }
});
export var selectQuestsIsTimeChallenge = memoize(function (quest) {
    var questBalancing = selectBalancingQuest(quest.id);
    return questBalancing.timeToLive !== undefined && questBalancing.eventId === undefined;
});
export var selectIsEventQuest = memoize(function (quest) {
    var questBalancing = selectBalancingQuest(quest.id);
    return questBalancing.eventId != undefined;
});
export var selectBalancingQuest = memoize(function (questId) { return selectBalancingQuests().get(questId); });
export var balancingQuestsMemoizedFunctions = [
    selectBalancingQuests,
    selectFinishedQuestRewards,
    selectFinishedQuestXp,
    selectQuestsIsTimeChallenge,
    selectBalancingQuest,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingQuests.ts
// module id = 234
// module chunks = 3